import { environment } from '../../../environments/environment';

export class Constant {
  localhost_url = environment.baseUrl;

  pdfURL = this.localhost_url + 'viewpdf.php?URL=';

  private dotsInterval: any = null;

  withAuthToken(url: string): string {
    const token = localStorage.getItem('token');
    if (!token) return url;
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}token=${encodeURIComponent(token)}`;
  }

  showLoader(message?: string) {
    const loader = document.getElementById('loader');
    if (loader) (<HTMLElement>loader).style.display = 'flex';
    if (message !== undefined) {
      const messageEl = document.getElementById('loaderMessage');
      if (messageEl) this.startMessageDots(messageEl, message);
    }
  }

  hideLoader() {
    const loader = document.getElementById('loader');
    if (loader) (<HTMLElement>loader).style.display = 'none';
    this.stopMessageDots();
    const messageEl = document.getElementById('loaderMessage');
    if (messageEl) messageEl.textContent = '';
  }

  private startMessageDots(el: HTMLElement, message: string) {
    this.stopMessageDots();
    const base = message.replace(/\.*$/, '');
    let dots = '.';
    el.textContent = base + dots;
    this.dotsInterval = setInterval(() => {
      dots = dots.length >= 3 ? '.' : dots + '.';
      el.textContent = base + dots;
    }, 500);
  }

  private stopMessageDots() {
    if (this.dotsInterval) {
      clearInterval(this.dotsInterval);
      this.dotsInterval = null;
    }
  }

  isValidEmail(email: string) {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  }

  isSuperAdmin() {
    if (localStorage.getItem('IsSuperAdmin') == 'true') {
      return true;
    }
    return false;
  }

  dateVisibility() { }
}